import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MIHttpClientService} from '../../shared/mi-http-client.service';
import {IRole} from "./role";
import {IRoleBulkOperationRequest} from "./role-details-modal/role-details-modal.component";
import {map} from "rxjs/operators";
import {IdName} from "../../shared/common-interfaces";

@Injectable({
  providedIn: 'root',
})
export class RolesService {

  constructor(
    private miClient: MIHttpClientService,
  ) {
  }

  getRoles(): Observable<IRole[]> {
    return this.miClient.get<any>('roles').pipe(
      map(items => items.map(item => ({...item, 'id': item.businessRoleId })))
    );
  }

  isUserAdmin(userId: number): Observable<boolean> {
    return this.miClient.get<any>('roles/isAdmin').pipe(map(status =>status));
  }

  getNonMIDBARoles() {
    return this.getRoles().pipe(map(roles => roles.filter((item => item.businessRoleType !== 'MIDBA_USER'))));
  }

  getNonMIDBARolesAsIdName(): IdName[] {
    const mappedRoles = [];
    this.getNonMIDBARoles()
      .subscribe(
        (roles) => {
          roles
            .forEach(obj => {
              mappedRoles.push({
                id: obj.businessRoleId,
                name: obj.businessRoleName,
              });
            });
        },
      );
    return mappedRoles;
  }

  getReportingRoles(roleId): Observable<any> {
    return this.miClient.get('roles/reportingRoles/' + roleId);
  }

  updateEmailsBulk(data: IRoleBulkOperationRequest): Observable<any> {
    return this.miClient.post('roles/bulkOperation', data);
  }

  getRole(id: number): Observable<IRole> {
    return this.miClient.get<IRole>('roles/roleId/' + id);
  }

  getRoleIdFromName(roleName: string, roles: IRole[]): number {
    let id = 0;
    roles.forEach(obj => {
      if (obj.businessRoleName === roleName) {
        id = obj.businessRoleId;
      }
    });
    return id;
  }


  getRolesAsIdName(): IdName[] {
    const mappedRoles = [];
    this.getRoles()
      .subscribe(
        (roles) => {
          roles
            .forEach(obj => {
              mappedRoles.push({
                id: obj.businessRoleId,
                name: obj.businessRoleName,
              });
            });
        },
      );
    return mappedRoles;
  }


}
